import { Epic, ofType } from "redux-observable";
import { catchError, debounceTime, map, switchMap } from "rxjs/operators";
import { assetService, CmsSpecificParams } from "../http/asset.service";
import { autocompleteService } from "../http/autocomplete.service";
import { Asset } from "../models/asset";
import { CMSAsset } from "../models/CMS/cmsAsset";
import {
  AppState,
  AssetActions,
  ASSET_ACTIONS,
  AutoCompleteAction,
  GetAssetsForCarouselAction,
  SetAssetsForCarouselAction,
  SetAutocompleteAction,
} from "../types/redux";
import { handleError } from "./error.redux";
import { cmsService } from "@client/http/cms.service";

export function AutoComplete(query: any): AutoCompleteAction {
  return { type: ASSET_ACTIONS.AUTOCOMPLETE, query };
}

export function SetAutocomplete(assets: any): SetAutocompleteAction {
  return { type: ASSET_ACTIONS.SET_AUTOCOMPLETE, assets };
}

export function GetAssetsForCarousel(
  query: string | null,
  sort: string | null,
  carouselId: string,
  cmsSpecificParams?: CmsSpecificParams
): GetAssetsForCarouselAction {
  return {
    type: ASSET_ACTIONS.GET_ASSETS_FOR_CAROUSEL,
    query,
    sort,
    carouselId,
    cmsSpecificParams,
  };
}

export function SetAssetsForCarousel(
  assets: Array<Asset | CMSAsset>,
  carouselId: string
): SetAssetsForCarouselAction {
  return { type: ASSET_ACTIONS.SET_ASSETS_FOR_CAROUSEL, assets, carouselId };
}

export default function assetReducer(
  state: AppState["assets"] = { assetsPerCarousel: [], autocomplete: [] },
  action: AssetActions
): AppState["assets"] {
  switch (action.type) {
    case ASSET_ACTIONS.SET_AUTOCOMPLETE:
      return {
        ...state,
        autocomplete: action.assets.assets || [],
      };
    case ASSET_ACTIONS.SET_ASSETS_FOR_CAROUSEL:
      return {
        ...state,
        assetsPerCarousel: [
          ...state?.assetsPerCarousel?.filter(
            (a) => a.carouselId != action.carouselId
          ),
          { carouselId: action.carouselId, assets: action.assets },
        ],
      };
    default:
      return state;
  }
}

// Epics
const autoComplete$: Epic = (action$) => {
  return action$.pipe(
    ofType(ASSET_ACTIONS.AUTOCOMPLETE),
    debounceTime(500),
    switchMap((a) => {
      return cmsService.getAssets(a.query).pipe(
        map((assets) => {
          return SetAutocomplete(assets);
        }),
        catchError(handleError)
      );
    })
  );
};

const getAssetsForCarousel$: Epic = (action$) => {
  return action$.pipe(
    ofType(ASSET_ACTIONS.GET_ASSETS_FOR_CAROUSEL),
    debounceTime(200),
    switchMap((a) => {
      // temporary solution to pass cmsSpecificParams while phasing out Redbee
      return assetService
        .getAssetsByQuery(a.query, a.sort, a.cmsSpecificParams)
        .pipe(
          map((assets) => {
            return SetAssetsForCarousel(assets, a.carouselId);
          }),
          catchError(handleError)
        );
    })
  );
};

export const assetEpics = [autoComplete$, getAssetsForCarousel$];
